// src/components/apps/coleco/ColecoMappingsTab.js
import * as React from 'react';
import Box from '@mui/material/Box';

import EditorTabPanel from '../../common/editor/EditorTabPanel';
import EditorSelect from '../../common/editor/EditorSelect';

// i18n
import { useI18n } from '../../../i18n/I18nContext';

function MappingField(props) {
  const {
    label,
    buttonName,
    object,
    setObject
  } = props;

  const { t } = useI18n();

  const NONE = 'none';

  let value = NONE;
  if (object.props.mappings) {
    value = object.props.mappings[buttonName];
    if (!value) {
      value = NONE;
    }
  }

  const setValue = (str) => {
    let mappings = object.props.mappings;
    if (!mappings) {
      mappings = {};
    }

    if (str === NONE) {
      delete mappings[buttonName];
    } else {
      mappings[buttonName] = str;
    }

    const props = { ...object.props, mappings };
    setObject({ ...object, props });
  };

  const menuItems = [];
  menuItems.push({ value: NONE, name: t('colecoMapNone') });

  const getName = (key, def) => {
    let name = null;
    if (object.props.descriptions) {
      name = object.props.descriptions[key];
    }
    if (!name) {
      name = def;
    }
    return name;
  };

  // Keypad buttons
  const KEYS = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '*', '0', '#'];
  for (let i = 0; i < KEYS.length; i++) {
    const key = KEYS[i];

    let labelKey = null;
    switch (key) {
      case '1': labelKey = 'colecoDescKeypad1'; break;
      case '2': labelKey = 'colecoDescKeypad2'; break;
      case '3': labelKey = 'colecoDescKeypad3'; break;
      case '4': labelKey = 'colecoDescKeypad4'; break;
      case '5': labelKey = 'colecoDescKeypad5'; break;
      case '6': labelKey = 'colecoDescKeypad6'; break;
      case '7': labelKey = 'colecoDescKeypad7'; break;
      case '8': labelKey = 'colecoDescKeypad8'; break;
      case '9': labelKey = 'colecoDescKeypad9'; break;
      case '*': labelKey = 'colecoDescKeypadStar'; break;
      case '0': labelKey = 'colecoDescKeypad0'; break;
      case '#': labelKey = 'colecoDescKeypadHash'; break;
      default: labelKey = null;
    }

    const defLabel = labelKey ? t(labelKey) : `Keypad ${key}`;
    menuItems.push({ value: key, name: getName(key, defLabel) });
  }

  // Buttons
  const isRoller = object.props.controlsMode === 3;
  const isSuper = object.props.controlsMode === 1;
  const isDriving = object.props.controlsMode === 2;

  // fire left
  let firelDefaultKey = 'colecoDescFireLeft';
  if (isDriving) {
    firelDefaultKey = 'colecoDescGasButton';
  } else if (isSuper) {
    firelDefaultKey = 'colecoDescYellowButton';
  }

  // fire right
  let firerDefaultKey = 'colecoDescFireRight';
  if (isDriving) {
    firerDefaultKey = 'colecoDescBrakeButton';
  } else if (isSuper) {
    firerDefaultKey = 'colecoDescOrangeButton';
  }

  menuItems.push({
    value: 'firel',
    name: getName('firel', t(firelDefaultKey)),
  });
  menuItems.push({
    value: 'firer',
    name: getName('firer', t(firerDefaultKey)),
  });

  if (isRoller) {
    menuItems.push({
      value: 'firel2',
      name: getName('firel2', t('colecoDescLeftFire2p')),
    });
    menuItems.push({
      value: 'firer2',
      name: getName('firer2', t('colecoDescRightFire2p')),
    });
  } else if (isSuper) {
    menuItems.push({
      value: 'blue',
      name: getName('blue', t('colecoDescBlueButton')),
    });
    menuItems.push({
      value: 'purple',
      name: getName('purple', t('colecoDescPurpleButton')),
    });
  }

  // Ensure value is in values
  let found = false;
  for (let i = 0; i < menuItems.length; i++) {
    const item = menuItems[i];
    if (item.value === value) {
      found = true;
      break;
    }
  }

  if (!found) {
    value = NONE;
  }

  return (
    <div>
      <EditorSelect
        label={label}
        value={value}
        menuItems={menuItems}
        onChange={(e) => { setValue(e.target.value); }}
      />
    </div>
  );
}

export default function ColecoMappingsTab(props) {
  const {
    tabValue,
    tabIndex,
    setObject,
    object
  } = props;

  const { t } = useI18n();

  return (
    <EditorTabPanel value={tabValue} index={tabIndex}>
      <Box sx={{ m: 1.5 }}>
        {t('colecoMapIntro')}
      </Box>
      <MappingField
        label={t('colecoMapAButton')}
        buttonName="a"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('colecoMapBButton')}
        buttonName="b"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('colecoMapXButton')}
        buttonName="x"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('colecoMapYButton')}
        buttonName="y"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('colecoMapLeftBumper')}
        buttonName="lb"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('colecoMapRightBumper')}
        buttonName="rb"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('colecoMapLeftTrigger')}
        buttonName="lt"
        object={object}
        setObject={setObject}
      />
      <MappingField
        label={t('colecoMapRightTrigger')}
        buttonName="rt"
        object={object}
        setObject={setObject}
      />
    </EditorTabPanel>
  );
}